import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information common to the dashboard sub-pages.
 */
export const DashboardPageStyles = makeStyles((theme: Theme) => ({
    // Root defines the workspace container.
    // This is scrollable.
    // root: {
    //     display: "flex",
    //     //flex: "1",
    //     justifyContent: "center",
    //     overflowY: "auto",
    // },
    root: {
        display: "flex",
        justifyContent: "center",
        overflowY: "auto",
    },

    workspace: {
        minHeight: "1px",
        // "& .pageLoader": {
        //     minHeight: "calc(100vh - 92px)",
        // },
    },
    titleRow: {
        alignItems: "center",
        backgroundColor: "#F9F9F9",
        display: "flex",
        justifyContent: "space-between",
        minHeight: "72px",
        "& > h5": {
            fontSize: "16px",
            fontWeight: "bold",
            padding: "12px 18px",
        },
    },
    plotsListDropdown: {
        position: "absolute",
        backgroundColor: "#ffffff",
        top: "56px",
        padding: "10px",
        borderRadius: "5px",
        boxShadow: "5px 5px 5px rgb(0 0 0 / 40%)",
        border: "1px solid #000000",
        "> div": {
            padding: "10px 0px",
        },
    },
    titleParent: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        position: "relative",
    },
    sidebar: {
        position: "fixed",
        left: 0,
        width: "75px",
        height: "calc(100vh - 50px)",
        background: "#ECECEC",
        boxShadow: "3px 0px 6px #00000029",
        display: "flex",
        flexDirection: "column",
        padding: "20px 0",
        zIndex: 1000,
        top: "50px",
        overflowY: "auto",
        overflowX: "hidden",
    },
    sidebarMenu: {
        position: "fixed",
        top: "0",
        left: "0",
        height: "100%",
        width: "250px",
        backgroundColor: "#ffffff",
        boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        zIndex: 1000,
    },
    sidebarMenuItem: {
        marginBottom: "20px",
        textAlign: "center",
        cursor: "pointer",
        transition: "background-color 0.2s",
        minHeight: "75px",
    },
    sidebarMenuItemHover: {
        backgroundColor: "#f5f5f5",
        borderRadius: "5px",
        padding: "10px",
    },

    [theme.breakpoints.down("sm")]: {
        pageWrapper: {
            height: "calc(100vh - 105px)",
        },
    },
}));

/**
 * Contains style information for the main page.
 */
export const MainPageStyles = makeStyles((theme: Theme) => ({
    root: {},
    drawerPaper: { borderRadius: "20px 20px 0 0", maxHeight: "80vh" },
    workspace: {
        width: "100%",
    },
    logoContainer: {
        display: "flex",
        justifyContent: "center",
        paddingTop: "13px",
        flex: "1 0 auto",
        "& > img": {
            height: "auto",
            maxWidth: "100%",
            maxHeight: "80px",
            [theme.breakpoints.down("sm")]: {
                maxHeight: "50px",
            },
        },
    },
    navigateToItem: {
        minHeight: "52px",
        "& > button": {
            "& > div.MuiCardContent-root": {
                padding: "12px 18px",
            },
        },
        "&:not(:last-child)": {
            // borderBottom: "1px dashed #ced4da",
        },
    },
    navigateToPropertyItem: {
        minHeight: "52px",
        "& > button": {
            "& > div.MuiCardMedia-root": {
                minHeight: "274px",
                width: "100%",
            },
            "& > div.MuiCardContent-root": {
                padding: "12px 18px",
            },
        },
    },
    navigateToArrow: {
        alignItems: "center",
        display: "flex",
        "& svg": {
            color: "#449b23",
            [theme.breakpoints.up("md")]: {
                height: "30px",
                width: "30px",
            },
        },
    },
    dropdownArrow: {
        justifySelf: "end",
        alignItems: "center",
        display: "flex",
        transform: "rotate(90deg)",
        marginLeft: "10px",
        "& svg": {
            fill: "#3aaa35",
            marginLeft: "-6px",
            marginRight: "-6px",
            fontSize: "16px",
        },
    },
    // pageTemplate: {
    //     paddingBottom: "80px",
    // },
    content: {
        background: "#3C3C3B",
        padding: "10px 30px",
    },
    contentTop: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("sm")]: {
            padding: "10px 20px 10px 20px",
        },
    },
    contentBottom: {
        padding: "10px 0 0",
        marginTop: "10px",
        borderTop: "1px solid #449B2350",
        display: "flex",
        gap: "20px",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            marginBottom: "10px",
            padding: "10px 30px 0 30px",
        },
    },
    contentBottomList: {
        display: "flex",
        gap: "14px",
        alignItems: "center",
    },
    contentBottomText: {
        fontSize: "12px",
        lineHeight: "15px",
        fontWeight: 400,
        letterSpacing: "-0.3px",
        color: "#FFFFFF",
        fontFamily: '"Inter", sans-serif',
        [theme.breakpoints.up("md")]: {
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: 400,
            letterSpacing: "-0.35px",
            color: "#FFFFFF",
        },
    },
    propertyTitleRow: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginRight: "18px",
    },
    contentBottomItem: {
        fontSize: "10px",
        lineHeight: "12px",
        fontWeight: 400,
        letterSpacing: "-0.2px",
        color: "#FFFFFF",
        fontFamily: '"Inter", sans-serif',
        display: "flex",
        alignItems: "center",
        gap: "4px",
        [theme.breakpoints.up("md")]: {
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: 400,
            letterSpacing: "-0.35px",
            color: "#FFFFFF",
        },
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        flex: "1",
        justifyContent: "space-between",
        marginRight: "18px",
        "& > div": {
            textAlign: "right",
        },
    },
    title: {
        display: "flex",
        fontSize: "21px",
        lineHeight: "normal",
        fontWeight: 400,
        letterSpacing: "-0.53px",
        color: "#FFFFFF",
        fontFamily: '"Inter", sans-serif',
    },
    subTitleRow: {},
    subTitle: {
        fontSize: "10px",
    },
    propertySubTitle: {
        fontSize: "14px",
        lineHeight: "17px",
        fontWeight: 400,
        letterSpacing: "-0.18px",
        color: "#FFFFFF",
        fontFamily: '"Inter", sans-serif',
        [theme.breakpoints.up("md")]: {
            fontSize: "12px",
            lineHeight: "15px",
            fontWeight: 400,
            letterSpacing: "-0.21px",
            color: "#FFFFFF",
        },
    },
    stickyFooterMenu: {
        left: 0,
        width: "100%",
        bottom: 0,
        display: "flex",
        zIndex: 1000,
        position: "fixed",
        background: "#ECECEC",
        boxShadow: "0px -1px 6px #00000029",
        overflow: "auto",
        "& > div": {
            padding: "12px",
            textAlign: "center",
            flex: "1 0 0",
            alignItems: "center",
            justifyContent: "center",

            "& p": {
                fontSize: "8px",
                lineHeight: "10px",
                fontWeight: 700,
                letterSpacing: "-0.2px",
                color: "#707070",
                fontFamily: '"Inter", sans-serif',
            },
            "& img": {
                height: "22px",
                width: "auto",
                marginBottom: "10px",
            },
            "&:hover": {
                background: "#E0E0E0",
                "& svg path": {
                    fill: "#449B23",
                },
                "& p": {
                    color: "#449B23",
                },
            },
        },
    },
    sidebar: {
        position: "fixed",
        left: 0,
        top: "50px",
        width: "75px",
        height: "calc(100vh - 50px)",
        background: "#ECECEC",
        boxShadow: "3px 0px 6px #00000029",
        display: "flex",
        flexDirection: "column",
        padding: "20px 0",
        zIndex: 1000,
    },
    sidebarMenu: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "40px",
    },
    sidebarMenuItem: {
        marginBottom: "0",
        textAlign: "center",
        cursor: "pointer",
        transition: "background-color 0.2s",
        minHeight: "75px",
        width: "100%",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        "&  p": {
            fontSize: "12px",
            lineHeight: "10px",
            fontWeight: 700,
            letterSpacing: "-0.2px",
            color: "#707070",
        },
        "&:hover": {
            background: "#E0E0E0",
            "& svg path": {
                fill: "#449B23",
            },
            "& p": {
                color: "#449B23",
            },
        },
    },
    sidebarMenuItemHover: {
        backgroundColor: "#f5f5f5",
        borderRadius: "5px",
        padding: "10px",
    },
    cardContainer: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        padding: "10px 0",
        rowGap: "20px",
        [theme.breakpoints.up("md")]: {
            padding: "50px 0",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
        },
    },
    cardContent: {
        textAlign: "center",
    },
    chooseCard: {
        width: "100%",
        borderRight: "1px solid #ECECEC",
        textAlign: "center",
        padding: "0 10px",
        "&:last-child": {
            borderRight: "none",
        },
    },
    chooseCardIcon: {
        marginBottom: "8px",
        textAlign: "center",
        width: "100%",
        "& > svg": {
            height: "22px",
            width: "22px",
            [theme.breakpoints.up("md")]: {
                height: "45px",
                width: "45px",
            },
        },
        [theme.breakpoints.up("md")]: {
            marginBottom: "16px",
        },
    },
    chooseCardTitle: {
        fontSize: "10px",
        lineHeight: "12px",
        fontWeight: "bold",
        letterSpacing: "-0.2px",
        color: "#3C3C3B",
        textTransform: "uppercase",
        fontFamily: '"Inter", sans-serif',
        [theme.breakpoints.up("md")]: {
            fontSize: "12px",
            lineHeight: "15px",
            fontWeight: "bold",
            letterSpacing: "-0.35px",
            color: "#3C3C3B",
            textTransform: "uppercase",
        },
    },
    chooseCardDateRow: {
        display: "flex",
        alignitems: "center",
        gap: "6px",
        flexWrap: "wrap",
        textAlign: "center",
        justifyContent: "center",
        "& > p": {
            fontSize: "8px",
            lineHeight: "12px",
            fontWeight: "normal",
            letterSpacing: "-0.2px",
            color: "#3C3C3B",
            fontFamily: '"Inter", sans-serif',
            marginBottom: "0px",
            [theme.breakpoints.up("md")]: {
                fontSize: "12px",
                lineHeight: "15px",
                fontWeight: "normal",
                letterSpacing: "-0.35px",
                color: "#3C3C3B",
            },
        },
        [theme.breakpoints.down("sm")]: {
            gap: "0px",
        },
    },
    cardIcon: {
        marginBottom: "8px",
        textAlign: "center",
        width: "100%",
        "& > img": {
            height: "24px",
            width: "auto",
            [theme.breakpoints.up("md")]: {
                height: "36px",
                width: "auto",
            },
        },
    },
    cardTitle: {
        textAlign: "center",
        fontWeight: "bold",
        textTransform: "uppercase",
        marginBottom: "8px",
        fontSize: "8px",
    },
    targetDateRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "8px",
    },
    targetDate: {
        marginLeft: "8px",
    },
    separatorLine: {
        borderBottom: "1px solid #e0e0e0",
        marginTop: "8px",
    },
    topCardsContainer: {
        display: "flex",
        justifyContent: "space-around",
        padding: "15px",
        gap: "4px",
    },
    topCard: {
        width: "100%",
        textAlign: "center",
        borderRadius: "4px",
        flex: "1 0 0",
        padding: "22px 12px",
        alignContent: "center",
    },
    topCardTitle: {
        marginBottom: "4px",
        fontSize: "14px",
        lineHeight: "17px",

        letterSpacing: "-0.12px",
        color: "#FFFFFF",
        textTransform: "uppercase",
        [theme.breakpoints.down("sm")]: {
            fontSize: "8px",
            lineHeight: "10px",
            fontWeight: "normal",
        },
    },
    topCardSubtitle: {
        fontSize: "21px",
        lineHeight: "26px",
        fontWeight: "bold",
        letterSpacing: "-0.53px",
        color: "#FFFFFF",
        textTransform: "uppercase",
        [theme.breakpoints.down("sm")]: {
            fontSize: "12px",
            lineHeight: "15px",
        },
    },

    imageCard: {
        width: "599px",
        height: "440px",

        [theme.breakpoints.down("sm")]: {
            height: "380px",
        },
        [theme.breakpoints.down("xs")]: {
            height: "210px",
        },
    },

    contentDescription: {
        textAlign: "left",
        fontSize: "14px",
        lineHeight: "1.5",
        fontWeight: "normal",
        letterSpacing: "-0.36px",
        color: "#FFFFFF",
        opacity: 1,
        marginTop: "40px",
        [theme.breakpoints.down("sm")]: {
            padding: "10px 30px 0 30px",
            marginTop: "0px",
            fontSize: "10px",
        },
    },
    infoCardRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "60px",
        paddingTop: "50px",
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
            gap: "15px",
            padding: "0px 15px 15px 15px",
        },
    },
    infoCardImage: {
        height: "80px",
        width: "170px",
        [theme.breakpoints.down("xs")]: {
            height: "60px",
            width: "120px",
        },
    },
    infoCard: {
        background: "#FFFFFF",
        boxShadow: "0px 2px 6px #00000040",
        borderRadius: "5px",
        padding: "12px 10px 25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        [theme.breakpoints.up("md")]: {
            padding: "25px 20px",
        },
        "& > .infoWarrantyCard": {
            width: "100%",
            paddingLeft: "20px",
            "& > .infoCardTitle": {
                color: "#449B23",
            },
            [theme.breakpoints.down("xs")]: {
                paddingLeft: "00px",
            },
        },
    },
    infoCardTitle: {
        fontSize: "12px",
        lineHeight: "15px",
        letterSpacing: " -0.35px",
        color: "#449B23",
        textTransform: "uppercase",
        fontWeight: "bold",
        fontFamily: '"Inter", sans-serif',
        [theme.breakpoints.up("md")]: {
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: "bold",
            letterSpacing: " -0.35px",
        },
    },
    infoCardSubTitle: {
        fontSize: "18px",
        lineHeight: "22px",
        fontWeight: "normal",
        color: "#3C3C3B",
        letterSpacing: "-0.3px",
        margin: "10px 0 0",
        [theme.breakpoints.up("md")]: {
            fontSize: "23px",
            lineHeight: "28px",
            fontWeight: "normal",
            margin: "12px 0 0",
        },
    },
    infoCardItems: {
        margin: "12px 0 0",
        [theme.breakpoints.up("md")]: {
            margin: "15px 0 0",
        },
        "& span": {
            fontSize: "10px",
            lineHeight: "12px",
            fontWeight: "normal",
            letterSpacing: "-0.35px",
            color: "#4A4A4A",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            margin: "0 0 4px",
            [theme.breakpoints.up("md")]: {
                fontSize: "14px",
                lineHeight: "17px",
                fontWeight: "normal",
                margin: "0 0 6px",
            },
            "& > span": {
                minWidth: "120px",
                display: "block",
                [theme.breakpoints.up("md")]: {
                    minWidth: "180px",
                },
            },
        },
        "& > .iconBox": {
            display: "flex",
            alignItems: "center",

            "& > span": {
                fontSize: "14px",
                lineHeight: "17px",
                fontWeight: "normal",
                color: "#4A4A4A",
                margin: "0px",
            },
            "&:last-child": {
                "& > span > span": {
                    textTransform: "lowercase",
                    textDecoration: "underline",
                },
            },
        },
    },
    infoCardIcon: {
        "& > svg": {
            color: "#449b23",
            height: "24px",
            width: "24px",
            cursor: "pointer",
            [theme.breakpoints.up("md")]: {
                height: "32px",
                width: "32px",
            },
        },
    },
    cardWithInfo: {
        display: "grid",
        gap: "60px",
        gridTemplateColumns: "1fr",
        padding: "15px",
        [theme.breakpoints.up("md")]: {
            gridTemplateColumns: "1fr 1fr",
            padding: "0px",
            height: "200px",
        },
    },
    smallmodel: {
        "& .MuiPaper-root": {
            background: "#F5F5F5",
            boxShadow: "0px -3px 6px #00000029",
            borderRadius: "20px",
            maxWidth: "625px",
        },
        "& .MuiDialogTitle-root": {
            background: "#3C3C3B",
            boxShadow: "0px -3px 6px #00000029",
            borderRadius: "20px 20px 0px 0px",
            padding: "18px 20px",
            "& h6": {
                letterSpacing: "-0.35px",
                color: "#FFFFFF",
                font: "normal normal bold 14px / 17px Inter",
            },
            "& p": {
                letterSpacing: "-0.35px",
                color: "#FFFFFF",
                textTransform: "uppercase",
                font: "normal normal normal 14px/17px Inter",
            },
            "& .MuiTypography-root.MuiTypography-h6": {
                "&  > div": {
                    gap: "10px",
                },
            },
        },
        "& .MuiIconButton-root": {
            color: "#fff",
        },
    },
    [theme.breakpoints.up("md")]: {
        workspace: {
            "& > div": {
                // display: "flex",
                // flexDirection: "row",
                margin: "0",

                "&.cards-container": {
                    height: "100%",
                    minHeight: "400px",
                },

                "&.company-logo-container": {
                    margin: "60px 0 48px",
                    padding: 0,
                },
            },
        },
        navigateToItem: {
            boxShadow: "none",
            border: "1px solid #ced4da !important",
            flex: "1",
            margin: "5px",
            borderRadius: "0",
            backgroundColor: "#F9F9F9",
            "&.active": {
                backgroundColor: "white",
            },

            "& > button": {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",

                "& > div.MuiCardMedia-root": {
                    minHeight: "274px",
                    flexGrow: 1,
                },
                "& > div.MuiCardContent-root": {
                    flexDirection: "column",
                },
            },
        },
        navigateToPropertyItem: {
            boxShadow: "none",
            // border: "1px solid #ced4da !important",
            flex: "2",
            margin: "5px",
            borderRadius: "0",
            backgroundColor: "#F9F9F9",
            display: "flex",
            alignItems: "stretch",
            border: "none",
            "&.active": {
                backgroundColor: "white",
            },

            "& > button": {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",

                "& > div.MuiCardContent-root": {
                    flexDirection: "column",
                },

                "& > div.MuiCardMedia-root": {
                    flexGrow: 1,
                },
            },
            "& > *": {
                [theme.breakpoints.up("md")]: {
                    flex: "1 0 0",
                    width: "100%",
                    height: "100%",
                    "& > div": {
                        width: "100%",
                    },
                },
            },
            "& > button > div": {
                minHeight: "440px",
                padding: "30px 60px !important",
            },
        },
        propertyTitleRow: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginRight: "18px",
        },
        titleRow: {
            alignItems: "flex-start",
            flexDirection: "row",
            marginRight: "0",
        },
        subTitleRow: {
            marginTop: "10px",
            minHeight: "48px",
            "& > p:first-child": {
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
        },
        stickyFooterMenu: {
            display: "none",
        },

        topCardsContainer: {
            padding: "0",
            gap: "8px",
        },
        topCard: {
            padding: "35px 20px",
        },
        topCardTitle: {
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: "normal",
            letterSpacing: "-0.21px",
            color: "#FFFFFF",
            textTransform: "uppercase",
        },
    },
    drawerPaperMobile: {
        "& .MuiPaper-root": {
            borderRadius: "22px 22px 0px 0px",
        },
        "& .progresses": {
            borderRadius: "22px 22px 0px 0px",
        },
    },
    drawerPaperMobileHeader: {
        background: "#3C3C3B",
        padding: "20px 22px",
        borderRadius: "20px 20px 0px 0px",
    },
    drawerPaperMobileHeaderInner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    drawerPaperMobileHeaderIcon: {},
    drawerPaperMobileHeaderTitle: {
        "& > h4": {
            fontSize: "14px",
            lineHeight: "20px",
            color: "#fff",
            fontWeight: "bold",
            letterSpacing: "-0.35px",
        },
        "& > p": {
            fontSize: "14px",
            lineHeight: "20px",
            color: "#fff",
            fontWeight: "normal",
            letterSpacing: "-0.35px",
        },
    },
    drawerPaperMobileHeaderCloseIcon: {
        color: "#fff",
        cursor: "pointer",
        height: "22px",
    },
}));

export const usePageAnimationStyles = makeStyles((theme: Theme) => ({
    container: {
        position: "absolute",
        top: "110px",
        right: 0,
        left: 0,
        bottom: 0,
        borderTop: "1px solid #CED4DA",
        backgroundColor: "white",
        transitionTimingFunction: "ease !important",
        "& > div": {
            height: "100%",
        },
    },
    pageWrapper: {
        position: "relative",
        height: "100%",

        [theme.breakpoints.up("md")]: {
            // backgroundColor: "#F9F9F9",
            padding: "20px",
            paddingLeft: "95px",
        },
        [theme.breakpoints.down("sm")]: {
            height: "calc(100% - 75px)",
            overflowX: "hidden",
            overflowY: "auto",
            paddingBottom: "80px",
        },
    },
}));

export const useHorizontalGalleryStyles = makeStyles(theme => ({
    hideScrollbar: {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
}));
